// 全局 polyfills
// 确保 regeneratorRuntime 在全局可用
import 'regenerator-runtime/runtime'
// umy-table 会直接从 `xe-utils/ctor` 调用若干方法（如 browse/each/lastIndexOf 等），需要先加载完整 xe-utils 完成 mixin
import 'xe-utils'

// 将 regeneratorRuntime 挂载到 window 对象上，确保第三方库可以访问
if (typeof window !== 'undefined') {
  window.regeneratorRuntime = regeneratorRuntime
}
